import {
  Award,
  BookOpen,
  BookOpenCheck,
  Brain,
  ClipboardCheck,
  Compass,
  HelpCircle,
  Library,
  ListChecks,
  Plug,
  Route,
  Users,
} from "lucide-react";
import { NavigationItem } from "./types";

const LEARNING_ADMIN = ["ROLE_SUPER_ADMIN", "ROLE_LEARNING_ADMIN"];

/**
 * Three groups, top to bottom, in the order a person meets them:
 *   Learn  — what every member sees: find a path, then work it.
 *   Guide  — people who follow someone else's progress (managers, coaches).
 *   Build  — CertainPath learning admins authoring the content.
 * Inside Build the pages run from the whole (paths, courses) to the parts
 * they are assembled from (modules, quizzes, tasks, badges, bundles).
 */
const navigation: NavigationItem[] = [
  // ---- Learn ----------------------------------------------------------------
  {
    name: "Learn",
    href: "#",
    icon: Compass,
    current: false,
    internalName: "learning_center_learn_divider",
    isDivider: true,
  },
  {
    name: "Learning Directory",
    href: "/hub/learning-center/directory",
    icon: Compass,
    current: false,
    internalName: "learning_directory",
  },
  {
    name: "My Learning",
    href: "/hub/learning-center/my-learning",
    icon: BookOpenCheck,
    current: false,
    internalName: "my_learning",
  },
  // ---- Guide (managers / coaches) -------------------------------------------
  {
    name: "Guide",
    href: "#",
    icon: Users,
    current: false,
    internalName: "learning_center_guide_divider",
    isDivider: true,
    roles: ["ROLE_MANAGER", "ROLE_OWNER_GM", "ROLE_COACH", "ROLE_SUPER_ADMIN"],
  },
  {
    name: "Team Learning",
    href: "/hub/learning-center/manager/my-team",
    icon: Users,
    current: false,
    internalName: "manager_team_progress",
    roles: ["ROLE_MANAGER", "ROLE_OWNER_GM", "ROLE_SUPER_ADMIN"],
  },
  {
    name: "Coaches Learning",
    href: "/hub/learning-center/coaches-learning",
    icon: ClipboardCheck,
    current: false,
    internalName: "coaches_learning",
    roles: ["ROLE_COACH", "ROLE_SUPER_ADMIN"],
  },
  // ---- Build (Learning Admin / Super Admin, CertainPath only) ---------------
  {
    name: "Build",
    href: "#",
    icon: Route,
    current: false,
    internalName: "learning_center_admin_divider",
    isDivider: true,
    roles: LEARNING_ADMIN,
    isCertainPathOnly: true,
  },
  {
    name: "Build Learning Paths",
    href: "/hub/learning-center/paths",
    icon: Route,
    current: false,
    internalName: "manage_learning_paths",
    roles: LEARNING_ADMIN,
    permissions: [],
    isCertainPathOnly: true,
  },
  {
    name: "Build Courses",
    href: "/hub/learning-center/admin/courses",
    icon: BookOpen,
    current: false,
    internalName: "course_management",
    roles: LEARNING_ADMIN,
    permissions: [],
    isCertainPathOnly: true,
  },
  {
    name: "Build Modules",
    href: "/hub/learning-center/admin/module-library",
    icon: Library,
    current: false,
    internalName: "module_library",
    roles: LEARNING_ADMIN,
    permissions: [],
    isCertainPathOnly: true,
  },
  {
    name: "Build Quizzes",
    href: "/hub/learning-center/admin/quizzes",
    icon: HelpCircle,
    current: false,
    internalName: "quiz_management",
    roles: LEARNING_ADMIN,
    permissions: [],
    isCertainPathOnly: true,
  },
  {
    name: "Build Custom Tasks",
    href: "/hub/learning-center/admin/custom-tasks",
    icon: ListChecks,
    current: false,
    internalName: "custom_tasks",
    roles: LEARNING_ADMIN,
    permissions: [],
    isCertainPathOnly: true,
  },
  {
    name: "Build Badges",
    href: "/hub/learning-center/admin/badges",
    icon: Award,
    current: false,
    internalName: "badge_management",
    roles: LEARNING_ADMIN,
    permissions: [],
    isCertainPathOnly: true,
  },
  {
    name: "Memories",
    href: "/hub/learning-center/admin/memories",
    icon: Brain,
    current: false,
    internalName: "memory_admin",
    roles: LEARNING_ADMIN,
    permissions: [],
    isCertainPathOnly: false,
  },
  {
    name: "Learning MCP Server",
    href: "/hub/learning-center/admin/path-mcp",
    icon: Plug,
    current: false,
    internalName: "learning_path_mcp",
    roles: LEARNING_ADMIN,
    permissions: [],
    isCertainPathOnly: true,
  },
];

const learningCenterConfig = {
  sectionName: "learning-center",
  defaultRoute: "/hub/learning-center/directory",
  navigation,
};

export default learningCenterConfig;
